<template>
  <nav class="modern-navbar navbar navbar-main navbar-expand-lg border-radius-xl mt-2 mb-4 mx-2" 
    v-bind="$attrs" 
    id="navbarBlur" 
    data-scroll="true"
    :class="{ 'is-absolute': isAbsolute, 'dark-mode': isDarkMode }">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :color="color" />
      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">

        </div>
        <ul class="navbar-nav justify-content-end">
          <router-link to="profile">
            <li class="nav-item d-flex align-items-center position-relative user-profile-item">
            <div class="user-avatar">
              <el-icon :size="20"><User /></el-icon>
            </div>
            <span class="username-text">{{ user.username }}</span>
          </li>
          </router-link>
          <li class="nav-item d-flex align-items-center position-relative">
            <div class="notification" @click="toggleNotifications">
              <div class="bell-container">
                <div class="bell"></div>
              </div>
              <span class="notification-count">{{ notifications.length }}</span>
            </div>

            <div v-if="showNotifications" class="notification-list">
              <div v-for="notification in notifications" :key="notification.id" class="notification-item">
                <div class="notification-title">{{ notification.title }}</div>
                <div class="notification-message">{{ notification.message }}</div>
              </div>
              <div v-if="notifications.length === 0" class="no-notifications">No new notifications</div>
            </div>
          </li>

          <li class="nav-item d-flex align-items-center">
            <a href="#" class="px-0 nav-link font-weight-bold lh-1">
              <label class="switch">
                <input type="checkbox" :checked="isDarkMode" @change="toggleDarkMode">
                <span class="slider"></span>
              </label>
            </a>
          </li>
          <li class="nav-item d-flex align-items-center">
            <el-select style="width:100px;" v-model="$store.state.language" @change="changeLanguage"
              placeholder="Select Language">
              <el-option label="English" value="en"></el-option>
              <el-option label="Arabic" value="ar"></el-option>
            </el-select>

          </li>
          <li class="nav-item dropdown d-flex align-items-center" :class="isRTL ? 'ps-2' : 'pe-2'">

            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton">
              <li class="mb-2">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="my-auto">
                      <img src="../../assets/img/team-2.jpg" class="avatar avatar-sm me-3" alt="user image" />
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">New message</span> from
                        Laur
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        13 minutes ago
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mb-2">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="my-auto">
                      <img src="../../assets/img/small-logos/logo-spotify.svg"
                        class="avatar avatar-sm bg-gradient-dark me-3" alt="logo spotify" />
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">New album</span> by
                        Travis Scott
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        1 day
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="my-auto avatar avatar-sm bg-gradient-secondary me-3">
                      <svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>credit-card</title>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero">
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(453.000000, 454.000000)">
                                <path class="color-background"
                                  d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z"
                                  opacity="0.593633743"></path>
                                <path class="color-background"
                                  d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z">
                                </path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        Payment successfully completed
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        2 days
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="toggleSidebar" class="p-0 nav-link text-body lh-1" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import MaterialInput from "@/components/MaterialInput.vue";
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import { RouterLink } from "vue-router";
import { User } from '@element-plus/icons-vue';

// import router from "../../router";

export default {

  name: "navbar",
  data() {
    return {
      user: {
        username: localStorage.getItem("username"),
        id: localStorage.getItem("userId"),
      },
      showMenu: false,
      showNotifications: false,
      notifications: [] // Initialize with your notification data
    };
  },
  props: ["minNav", "color"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(['toggleDarkMode']),
    toggleSidebar() {
      this.navbarMinimize();
    },

    fetchNotifications() {
      // Fetch notifications from local storage or an API
      this.notifications = JSON.parse(localStorage.getItem('notifications')) || [];
    },
    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
    },

    changeLanguage(language) {
      this.$store.dispatch("changeLanguage", language); // Update language in Vuex and localStorage
      this.$i18n.locale = language; // Set the new language in vue-i18n
    },
  },
  mounted() {
    this.$store.dispatch('initializeDarkMode');
    this.fetchNotifications(); // Fetch notifications on mount
  },
  components: {
    RouterLink,
    Breadcrumbs,
    MaterialInput,
    User,
  },
  computed: {
    isDarkMode() {
      // Access the `isDarkMode` state from Vuex or another state management system
      return this.$store.state.isDarkMode;
    },
    ...mapState(["isRTL", "isAbsolute"]),
    ...mapGetters(['isDarkMode']),

    currentRouteName() {
      return this.$route.name;
    },
  },

  created() {
    // Initialize the language from Vuex or localStorage when the component is created
    this.$i18n.locale = this.$store.state.language;
  },
};
</script>


<style scoped>
/* Modern Navbar Styles */
.modern-navbar {
  background: linear-gradient(135deg, rgba(26, 32, 53, 0.95) 0%, rgba(15, 20, 25, 0.95) 100%) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-navbar.dark-mode {
  background: linear-gradient(135deg, rgba(10, 14, 20, 0.95) 0%, rgba(5, 7, 9, 0.95) 100%) !important;
  border-color: rgba(255, 255, 255, 0.05);
}

.modern-navbar.is-absolute {
  margin-top: 1rem;
}

.user-profile-item {
  padding: 8px 16px;
  border-radius: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.user-profile-item:hover {
  background: rgba(102, 126, 234, 0.1);
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-left: 12px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.username-text {
  color: #ffffff;
  font-weight: 500;
  font-size: 0.95rem;
}

.notification-title {
  color: #ffff;
}

.bell {
  border: 2.17px solid #22006b;
  border-radius: 10px 10px 0 0;
  width: 15px;
  height: 17px;
  background: transparent;
  display: block;
  position: relative;
  top: -3px;
}

.bell::before,
.bell::after {
  content: "";
  background: #22006b;
  display: block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 2.17px;
}

.bell::before {
  top: 100%;
  width: 20px;
}

.bell::after {
  top: calc(100% + 4px);
  width: 7px;
}

/*container main styling*/
.notification-list {
  position: absolute;
  top: 50px;
  right: -220px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  width: 320px;
  max-height: 400px;
  overflow-y: auto;
  padding: 12px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.notification-item {
  padding: 14px 18px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 8px;
  border-radius: 10px;
}

.notification-item:hover {
  background: rgba(102, 126, 234, 0.08);
  transform: translateX(-2px);
}

.no-notifications {
  text-align: center;
  padding: 10px;
  color: #999;
}

.notification-count {
  color: white;
  /* Set the notification count color */
  font-size: 10px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  right: 8px;
  top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}


.notification {
  background: transparent;
  border: none;
  padding: 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification:hover {
  background: rgba(102, 126, 234, 0.1);
}

/*notifications number with before*/
.notification::before {
  content: "";
  color: white;
  font-size: 10px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  right: 8px;
  top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/*container background hover effect*/
.notification:hover {
  background: rgba(170, 170, 170, 0.062);
}

/*container animations*/
.notification:hover>.bell-container {
  animation: bell-animation 650ms ease-out 0s 1 normal both;
}

/*bell ring and scale animation*/
@keyframes bell-animation {
  20% {
    transform: rotate(15deg);
  }

  40% {
    transform: rotate(-15deg);
    scale: 1.1;
  }

  60% {
    transform: rotate(10deg);
    scale: 1.1;
  }

  80% {
    transform: rotate(-10deg);
  }

  0%,
  100% {
    transform: rotate(0deg);
  }
}

/* From Uiverse.io by satyamchaudharydev */
/* The switch - the box around the slider */
.switch {
  display: block;
  --width-of-switch: 3.5em;
  --height-of-switch: 2em;
  /* size of sliding icon -- sun and moon */
  --size-of-icon: 1.4em;
  /* it is like a inline-padding of switch */
  --slider-offset: 0.3em;
  position: relative;
  width: var(--width-of-switch);
  height: var(--height-of-switch);
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f4f4f5;
  transition: .4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: var(--size-of-icon, 1.4em);
  width: var(--size-of-icon, 1.4em);
  border-radius: 20px;
  left: var(--slider-offset, 0.3em);
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(40deg, #ff0080, #ff8c00 70%);
  ;
  transition: .4s;
}

input:checked+.slider {
  background-color: #303136;
}

input:checked+.slider:before {
  left: calc(100% - (var(--size-of-icon, 1.4em) + var(--slider-offset, 0.3em)));
  background: #303136;
  box-shadow: inset -3px -2px 5px -2px #8983f7, inset -10px -4px 0 0 #a3dafb;
}
</style>